var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.941162,
    width: 30.1176,
    height: 30.1176,
    rx: 15.0588,
    fill: "#1A1F71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6803 12.6769L13.255 19.3401H11.5311L12.9564 12.6769H14.6803ZM21.9324 16.9794L22.8401 14.4771L23.3615 16.9794H21.9324ZM23.8567 19.3401H25.4505L24.058 12.6769H22.5874C22.2558 12.6769 21.9771 12.8694 21.8534 13.1654L19.2667 19.3401H21.077L21.436 18.3448H23.6477L23.8567 19.3401ZM19.3566 17.1646C19.3638 15.4064 16.9254 15.3088 16.9414 14.5231C16.9472 14.2844 17.1747 14.03 17.6727 13.9651C17.9194 13.9332 18.6009 13.9077 19.3728 14.2634L19.6748 12.8496C19.26 12.6996 18.7263 12.5553 18.0624 12.5553C16.3582 12.5553 15.1594 13.4604 15.1499 14.7576C15.1387 15.7171 16.0061 16.2518 16.6584 16.5714C17.3304 16.8978 17.5557 17.1075 17.5525 17.3992C17.5478 17.8462 17.016 18.0441 16.5215 18.0515C15.6545 18.0653 15.1519 17.8172 14.751 17.6305L14.4381 19.0911C14.8415 19.2759 15.5848 19.4365 16.3547 19.4447C18.1663 19.4447 19.3513 18.5499 19.3566 17.1646ZM12.2169 12.6769L9.42396 19.3401H7.60168L6.22715 14.0223C6.14392 13.6955 6.07145 13.5752 5.81782 13.4371C5.40332 13.2119 4.71885 13.0014 4.11719 12.8703L4.15778 12.6769H7.09143C7.46479 12.6769 7.80097 12.9255 7.88637 13.3559L8.61267 17.212L10.4057 12.6769H12.2169Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1637aa77073f62b070bd2a86ce74b611.svg";
export { ForwardRef as ReactComponent };